// src/api_scripts/getentrypointsList.js
import { fetchAllPages } from "../paginationUtils";

const getEntryPoint = async (entrypointList, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/entry-point`;

  try {
    // Use the pagination utility to fetch all pages
    const entrypointsListsArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Entry Points");
    console.log("Get Entry Points List API Response Data (all pages):", entrypointsListsArray.length, "items");
    return entrypointsListsArray;

  } catch (error) {
    console.error(`Error fetching Entry Points:`, error);
    throw error; // Re-throw the error to be caught by the calling function
  }
};

export default getEntryPoint;
